import { render } from "./FeedConfigsTable.vue?vue&type=template&id=3e32a17b"
import script from "./FeedConfigsTable.vue?vue&type=script&lang=js"
export * from "./FeedConfigsTable.vue?vue&type=script&lang=js"

import "./FeedConfigsTable.vue?vue&type=style&index=0&id=3e32a17b&lang=css"

import exportComponent from "/Users/biriukov/Documents/Projects/generate-web-prices/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__